import { Badge, Flex, Heading } from '@chakra-ui/react'

interface HeaderProps {
  date: string
  version: string
}

export default function NoteHeader({ date, version }: HeaderProps) {
  return (
    <Flex justifyContent="space-between" alignItems="center" p={1} w="full" gap={4}>
      <Heading color="primary" fontWeight="bold">
        {date}
      </Heading>
      {version && <Badge colorScheme="primary">v {version}</Badge>}
    </Flex>
  )
}
